import config from 'config';

export const getImageUrl = (imagePath: string | null | undefined, width?: number, height?: number): string | null => {
  if (!imagePath) return null;

  const queryParameters: Record<string, number> = {};
  if (width) queryParameters.width = width;
  if (height) queryParameters.height = height;
  // @ts-ignore
  const queryString = new URLSearchParams(queryParameters).toString();
  const fullQueryString = queryString ? `?${queryString}` : '';

  return `${imagePath}${fullQueryString}`;
};

export const getLogoUrl = (id: string): string => {
  const { logoUrlBase } = config.api;
  return `${logoUrlBase}${id}.png`;
};
